import {
  DndContext,
  MouseSensor,
  pointerWithin,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { FC, PropsWithChildren } from "react";

import { useCoursesDragHandling } from "@ryde/redux";

export const CoursesDragContextWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const { handleDragStart, handleDragEnd, handleDragOver, handleDragCancel } =
    useCoursesDragHandling();

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
  );
  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      sensors={sensors}
      collisionDetection={pointerWithin}
    >
      {children}
    </DndContext>
  );
};
